/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    RegistrationCompleteRequestData,
    RegistrationCompleteResponse,
    RegistrationRequestData,
    RegistrationResponseData,
    RegistrationVerifyRequestData,
    RegistrationVerifyUserRequest,
    RegistrationVerifyUserResponse
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class RegistrationApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht das Verifizieren einer Mailadresse via der im Registrierungslink enthaltenen UUID.
 * @summary Verifiziere Registrierung via Puma
 */
 postVerifyRegistrationPuma<TData = void>(registrationVerifyRequestData: RegistrationVerifyRequestData, options?: HttpClientBodyOptions): Observable<TData>;
 postVerifyRegistrationPuma<TData = void>(registrationVerifyRequestData: RegistrationVerifyRequestData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postVerifyRegistrationPuma<TData = void>(registrationVerifyRequestData: RegistrationVerifyRequestData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postVerifyRegistrationPuma<TData = void>(
    registrationVerifyRequestData: RegistrationVerifyRequestData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/registration/verify`,
      registrationVerifyRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/registration/verify`,
      registrationVerifyRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/registration/verify`,
      registrationVerifyRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Verifizieren der Registrierungsdaten eines Nutzers.
 * @summary Verifiziere Nutzerregistrierung via Puma
 */
 postVerifyUser<TData = RegistrationVerifyUserResponse>(registrationVerifyUserRequest: RegistrationVerifyUserRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postVerifyUser<TData = RegistrationVerifyUserResponse>(registrationVerifyUserRequest: RegistrationVerifyUserRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postVerifyUser<TData = RegistrationVerifyUserResponse>(registrationVerifyUserRequest: RegistrationVerifyUserRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postVerifyUser<TData = RegistrationVerifyUserResponse>(
    registrationVerifyUserRequest: RegistrationVerifyUserRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/registration/verifyUser`,
      registrationVerifyUserRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/registration/verifyUser`,
      registrationVerifyUserRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/registration/verifyUser`,
      registrationVerifyUserRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Abschließen der Registrierung durch Übersenden der Kundendaten.
 * @summary Schließe Registrierung ab
 */
 postCompleteRegistration<TData = RegistrationCompleteResponse>(registrationCompleteRequestData: RegistrationCompleteRequestData, options?: HttpClientBodyOptions): Observable<TData>;
 postCompleteRegistration<TData = RegistrationCompleteResponse>(registrationCompleteRequestData: RegistrationCompleteRequestData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postCompleteRegistration<TData = RegistrationCompleteResponse>(registrationCompleteRequestData: RegistrationCompleteRequestData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postCompleteRegistration<TData = RegistrationCompleteResponse>(
    registrationCompleteRequestData: RegistrationCompleteRequestData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/registration/complete`,
      registrationCompleteRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/registration/complete`,
      registrationCompleteRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/registration/complete`,
      registrationCompleteRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Prüfen der per Brief übersendeten Registrierungsdaten (Benutzer-ID + PIN).
 * @summary Prüfe Registrierungsdaten
 */
 postCheckRegistration<TData = RegistrationResponseData>(registrationRequestData: RegistrationRequestData, options?: HttpClientBodyOptions): Observable<TData>;
 postCheckRegistration<TData = RegistrationResponseData>(registrationRequestData: RegistrationRequestData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postCheckRegistration<TData = RegistrationResponseData>(registrationRequestData: RegistrationRequestData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postCheckRegistration<TData = RegistrationResponseData>(
    registrationRequestData: RegistrationRequestData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/registration/check`,
      registrationRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/registration/check`,
      registrationRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/registration/check`,
      registrationRequestData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

